












import { Vue, Component } from 'vue-property-decorator'

@Component
export default class ActivityShareQrcode extends Vue {
  own_url !: string

  get qrcodeSrc() {
    return `${window.location.origin}/api/v1/general/qrcode?content=${encodeURIComponent(this.own_url)}`
  }

  closeMask() {
    const appInstance = document.body.querySelector('#app') as Element
    appInstance.classList.remove('privacy-masking')
    // @ts-ignore
    this.$el.parentNode.removeChild(this.$el)
  }
}
